import { forwardRef } from 'react';
import { Link } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RouterLink = forwardRef(function RouterLink(props: any, ref) {
  return <Link ref={ref} to={props?.href} {...props} />;
});
